// Generated i18n file
export default {
  title: '東京メトロ24時間券',
  notes: {
    item1:
      '同時に複数枚購入した乗車券は、ご利用開始前にそれぞれのスマートフォン端末へSNS等により分配することが可能です。',
    item2:
      '1台の端末で複数枚のQRコードを使用する場合は、必ずバウチャーをお持ちのお客様が最後に通過するようにしてください。',
    description2:
      '※通常よりも改札機の通過のお手続きに時間を要し、ご希望の列車等にご乗車できない場合がございますので、お時間に余裕をもってご利用をお願いいたします。',
    item3:
      '本乗車券を使用して東京メトロ線以外の路線へ乗車することはできません。',
    item4: 'QRコードの印刷物やスクリーンショットではご利用いただけません。',
    description4:
      '※スマートフォン等の端末の紛失や電池切れ等により本乗車券の効力が画面表示で確認できない場合、乗車券をお持ちでないものとして、本乗車券の有効区間を含むご乗車区間の所定運賃をお支払いただきます。駅で電源等を提供することはいたしかねますので、あらかじめご了承ください。',
    item5:
      '乗車券の有効期間および有効期限を過ぎると、ご利用いただけません。（利用開始ボタンを押下後、当日の終電までに自動改札機等利用がない場合もご利用いただけません。）',
    item6:
      '払戻しは、有効期間内かつ利用開始前に限り、購入履歴ページにて、1件（1決済）につき払戻手数料220円が発生します。',
    item7: '有効な乗車券画面の提示によって、振替輸送の対象となります。',
    item8:
      'QR乗車券において利用できない等のご不明点は、「予約番号」と「お名前」を明記の上、購入先までご連絡をお願いいたします。',
    description8: 'QRコードは株式会社デンソーウェーブの登録商標です。',
    title: '注意事項'
  },
  explain: {
    description1:
      '東京メトロ線内限定の乗車券で、使用開始から24時間、全9路線が乗り降り自由なお得な乗車券です。',
    description2:
      '東京メトロ線の初乗り運賃180円の区間（1〜6km）で乗り降りする場合、4回以上乗るだけでおトクに！',
    title: '利用説明',
    area: '使用可能区間',
    areaValue: '東京メトロ線全線',
    howToUse: '使用方法',
    step1: {
      alt: 'QRデジタルチケット購入',
      description:
        '① QR乗車券は、お手持ちのスマートフォンで事前にQRデジタルチケットを購入することで、自動改札機にQRコードをかざしてご利用いただけるサービスです。'
    },
    step2: {
      alt: 'QRコード対応改札口で乗り降り',
      description: '② QRコードに対応する改札口で乗り降りできます。',
      tip: '※QRコードに対応していない改札口では、改札口の駅係員へお問い合わせください。不在の場合は改札口のインターホンにて駅係員をお呼び出しください。'
    },
    step3: {
      alt: '利用開始ボタンを押す',
      description:
        '③ ご利用前に必ず「利用開始」ボタンを押下し、入場処理を行ってください。「利用開始」ボタン押下時点から利用期間が開始されますので、払戻しが不可能となります。必ずご利用直前に押下してください。'
    },
    validityDescription:
      '購入後90日以内の1日において、利用開始ボタンを押下した当日の初回改札利用から24時間に限り有効',
    validityNotice:
      '※利用開始を押下した当日中にご利用がない場合は、無効となります。',
    validityTitle: '有効期間または有効期限'
  },
  faq: {
    title: 'よくある質問',
    faqList: [
      {
        answer: `スマートフォン1つでキャッシュレスで購入・利用ができるおトクなきっぷです。
お持ちのスマートフォンに表示されるＱＲコードとアニメーションが、きっぷの代わりになります。
以下の券種を発売しております。
・Tokyo Subway 24/48/72-Hour Ticket（QR）
・東京メトロ都営地下鉄共通1日乗車券（QR）
・東京メトロ24時間券（QR）
`,
        question: 'ＱＲ企画乗車券とは？'
      },
      {
        answer: `専用Webサイトにて「Google」「Email」のアカウントからログイン後、デジタルチケットの種類を選択し、クレジットカードで決済してください。
※登録する姓名は、半角ローマ字で入力してください。`,
        question: '購入方法は？'
      },
      {
        answer: 'VISA、MasterCard、JCB、AmericanExpress、Diners',
        question: 'カード決済で利用可能なクレジットカードは？'
      },
      {
        answer: `クレジットカード会社において３Ｄセキュアが必要となります。
設定含め、その他、クレジットカードでの決済ができない場合もクレジットカード会社へお問い合わせください。`,
        question: 'クレジットカードの決済が使えないとき？'
      },
      {
        answer: `ＱＲ企画乗車券は、スマートフォン等の情報端末をお持ちでないと利用できません。また、画面のスクリーンショットではご利用いただけません。`,
        question:
          'スマートフォンを持っていないとＱＲ企画乗車券を利用できませんか？'
      },
      {
        answer: `【年齢区分】
・大人（12歳以上）
  大人運賃。ただし、13歳未満の小学生は、小児運賃を適用します。
・小児（6歳以上12歳未満）
  小児運賃。ただし、6歳で小学校入学前の場合は、幼児とします。
`,
        question: '乗車券の年齢区分は？'
      },
      {
        answer: `代表者様が複数人分まとめてＱＲ企画乗車券を購入しご利用になる場合において、複数枚同時にご購入された場合は、ご利用開始前にそれぞれのスマートフォン端末へＳＮＳ等を使用し、分配をお願いいたします。分配せずに１台の端末で複数枚の乗車券を利用する場合は、通常よりも改札機通過のお手続き時間を要し、ご利用の列車にご乗車できない場合がございますので、お時間に余裕をもってご利用をお願いいたします。
１台の端末で複数枚のＱＲ企画乗車券を利用して自動改札機を通過する場合は、必ずバウチャーをお持ちのお客様が最後に通過するようにしてください。
`,
        question: '乗車券の分配機能とは？'
      },
      {
        answer:
          'ＱＲ企画乗車券の利用日（乗車日）において、「利用開始」ボタンを押した場合は、その日の最終電車までに自動改札機のご利用がない場合は乗車券が無効となります。必ず乗車する日の始発時間以降に「利用開始ボタン」を押してください。なお、自動改札機を通過した時からデジタルチケットの有効期限が開始されます。',
        question: '乗車券画面の「利用開始」とは？'
      },
      {
        answer:
          '一部駅においては、ＱＲ企画乗車券に対応する自動改札機が無い改札口がございます。改札口の駅係員へお問い合わせください。乗車時もしくは降車時に駅務機器での処理が必要となります。また、駅係員が不在の改札口については、インターフォン等にて駅係員をお呼び出しください。駅事務所から距離がある場合は駅係員到着までお時間がかかる場合がございますので、お時間に余裕を持ってご利用をお願いいたします。',
        question: 'ＱＲ企画乗車券に対応する改札機が無い場合は？'
      },
      {
        answer: `有効期間内で利用開始前の乗車券に限り、販売サイト上で払戻しが出来ます。（１決済につき、払戻し手数料220円）
複数枚のＱＲ企画乗車券を購入して払戻しした場合、一部の乗車券の払戻しが出来ず、すべての乗車券が払戻しされますので、ご注意ください。`,
        question: '払戻しはできますか？'
      },
      {
        answer: `スマートフォン等の情報端末を紛失したり、電池切れ等でＱＲ企画乗車券の画面情報を駅社員が確認できない場合、有効な乗車券をお持ちでないものとして、実際に乗車した区間の所定運賃を現金、ＩＣカードにて収受いたします。端末の充電状況にはご注意ください。駅で電源などを提供することはいたしかねますので、あらかじめご了承ください。`,
        question:
          '使用中にスマートフォンの故障や電源が切れた場合にはどうすればよいですか？'
      },
      {
        answer: '有効な乗車券を提示可能であれば、振替輸送の対象となります。',
        question: '振替輸送の対象となりますか？'
      },
      {
        answer: `メール問い合わせ連絡先にご連絡ください。
メールアドレス helpcenter@linktivity.co.jp
`,
        question: '購入後の確認メールが届かない場合は？'
      },
      {
        answer:
          '購入後や利用開始後にＱＲ企画乗車券が利用できない等のご不明点は「予約番号」「お名前」を明記の上、購入先までご連絡をお願いいたします。',
        question: 'ＱＲ企画乗車券が利用できない場合は？'
      }
    ]
  },
  ticket: {
    buy: '購入',
    qrcode: {
      desc: 'QRコードで利用',
      title: '東京メトロ24時間券'
    },
    ticketLink: {
      qrcode:
        'https://tokyometrods.triplabo.com/ja/product/prod_agptukhko553njmyzlfzyjd2ie?utm_source=tokyometro-digital-ticket.triplabo.jp&utm_medium=referral&utm_campaign=v3_migration&utm_content=tokyo_metro_24h_ticket_all_languages'
    }
  }
};
